import { Box, Stack, Typography } from "@mui/material"

import { Grid, ResponsiveImage, ResponsiveImageType, WYSIWYG, type FC } from ".."

export type SplitImageTextProps = {
  image: ResponsiveImageType
  title?: string
  content: string
}

const SplitImageText: FC<SplitImageTextProps> = ({ image, title, content }) => {
  return (
    <Grid component="article" sx={{ rowGap: 10 }}>
      <Box gridColumn={{ xs: "1 / -1", lg: "2 / -2" }}>
        <ContentItem {...{ image, title, content }} />
      </Box>
    </Grid>
  )
}

export default SplitImageText

/** A sub-component for content item */
const ContentItem: FC<SplitImageTextProps> = ({ image, title, content }) => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    gap={{ xs: 10, md: 20, lg: 32 }}
    justifyContent="space-between"
  >
    <Box flex={{ md: "1 1 388px" }}>
      <Box width="100%" borderRadius={1.5} overflow="hidden" sx={{ aspectRatio: "1" }}>
        <ResponsiveImage image={image} />
      </Box>
    </Box>
    <Box flex="1 2 100%" alignSelf="center" maxWidth={745}>
      {title && (
        <Typography variant="heading.lg" component="h2" sx={{ mb: { xs: 5, md: 10 } }}>
          {title}
        </Typography>
      )}
      <WYSIWYG content={content} />
    </Box>
  </Stack>
)
